import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { CrudWarehouseService } from "app/_services/MasterCrudOps/crud-warehouse.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { States } from "app/_models/states";
import { Cities } from "app/_models/cities";
import { StateService } from "app/_services/state.service";
import { OptionslistService } from "app/_services/optionslist.service";
import { UserOptionsDto } from "app/_models/optionsList/options";

declare const swal: any;

@Component({
  selector: "app-add-warehouse",
  templateUrl: "./add-warehouse.component.html",
})
export class AddWarehouseComponent implements OnInit {
  addWarehouseForm: UntypedFormGroup;
  states: States[] = [];
  state: States;
  selectedStates: States[] = [];
  cities: Cities[] = [];
  city: Cities;
  userOptionsDto: UserOptionsDto[] = [];
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly stateService: StateService,
    private readonly optionslistService: OptionslistService,
    private readonly crudWarehouseService: CrudWarehouseService,
    private readonly dialogRef: MatDialogRef<AddWarehouseComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
  }

  ngOnInit() {
    this.initilizeForm();
    this.getstates();
    this.getUsers();
  }
  initilizeForm() {
    this.addWarehouseForm = this.formBuilder.group({
      warehouseName: [null, [Validators.required, Validators.maxLength(50)]],
      description: [null, [Validators.required, Validators.maxLength(100)]],
      stateId: [null, [Validators.required]],
      cityId: [null, [Validators.required]],
      address: [null, [Validators.required, Validators.maxLength(250)]],
      warehouseManager: null,
    });
  }

  getstates() {
    this.stateService.getStates().subscribe((states) => {
      this.states = states;
      this.selectedStates = states;
    });
  }
  onSelectionchange(e) {
    this.stateService.getCityByStateId(e.value).subscribe((state) => {
      this.cities = state.cities;
    });
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }

  getUsers() {
    this.optionslistService
      .getActiveDatacentereManagersOptions()
      .subscribe((data) => {
        if (!data.didError) {
          this.userOptionsDto = data.model;
        }
      });
  }

  search(value: string) {
    let filter = value?.toLowerCase() ?? "";
    this.selectedStates = [];

    if (!value) {
      this.selectedStates = [...this.states];
      return this.selectedStates;
    }

    for (const state of this.states) {
      if (state.stateName.toLowerCase().includes(filter)) {
        this.selectedStates.push(state);
      }
    }

    return this.selectedStates;
  }

  saveHouse() {
    let model = {
      warehouseName: this.addWarehouseForm.value.warehouseName,
      description: this.addWarehouseForm.value.description,
      cityId: this.addWarehouseForm.value.cityId,
      stateId: this.addWarehouseForm.value.stateId,
      address: this.addWarehouseForm.value.address,
      warehouseManager: this.addWarehouseForm.value.warehouseManager,
    };
    this.crudWarehouseService.saveWareHouse(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
        }
        let result = {
          status: true,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        };
        this.dialogRef.close(result);
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }

        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }
}
